import { BehaviorSubject } from 'rxjs';

/**
 * Tree node.
 *
 * Each node in the tree is made of a FilterTreeNode.
 * Works for both parent and child nodes.
 *
 * @param item Display name of the node.
 * @param [checked=true] Whether the node is checked on init.
 * @param children Array of child nodes.
 */
export class FilterTreeNode {

  /** Child nodes. */
  public children: BehaviorSubject<FilterTreeNode[]>;

  /** Display label. */
  public label: string;

  /** Id of the child node. Pairs with *key* property. */
  public value: string;

  /** Property to filter on. */
  public key: string;

  /** Whether the checkbox is checked. */
  public active: boolean;

  constructor(
    label = '',
    value = null,
    key = null,
    active = false,
    children = []
  ) {
    this.label = label;
    this.value = value;
    this.key = key;
    this.active = active;
    this.children = new BehaviorSubject(children);
  }
}
